import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root"
})
export class FileUploadService {
	constructor(private http: HttpClient) {}

	upload(fileArray: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/PostHomeConfig`, fileArray);
	}

	getFiles(): Observable<any> {
		return this.http.get(`${environment.urlApi}/GetHomeConfig`);
	}

	getHomeFiles(): Observable<any> {
		return this.http.get(`${environment.urlApi}/GetHome`);
	}
}
